import React, { useRef, useState } from "react";
import Select from "react-dropdown-select";
import DatePicker from "react-datepicker";

const NewRoomSearch = ({ onSubmit, onCancel, searchMembers = [] }) => {
    const [searchDate, setSearchDate] = useState(new Date());
    const [startTime, setStartTime] = useState(searchDate);
    const [endTime, setEndTime] = useState(startTime);
    const reasonRef = useRef();
    const patientConsentRef = useRef();
    const patientPresentRef = useRef();
    const priorToSearchRef = useRef();
    const postToSearchRef = useRef();
    const commentRef = useRef();

    // Local state
    const [selectedMembers, setMembers] = useState([]);

    const options = searchMembers.map((item) => ({
        id: item.id,
        display: `${item.surname} ${item.first_name} (${item.email})`,
    }));
    return (
        <form
            method="POST"
            onSubmit={(e) => {
                e.preventDefault();
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                onSubmit({
                    searchMembers: selectedMembers.map((i) => i.id),
                    searchDate,
                    startTime,
                    endTime,
                    reason: reasonRef.current.value,
                    patientConsent: patientConsentRef.current.value,
                    patientPresent: patientPresentRef.current.value,
                    priorToSearch: priorToSearchRef.current.value,
                    postToSearch: postToSearchRef.current.value,
                    comment: commentRef.current.value,
                });
            }}
        >
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Search Detail</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Date of Search*</strong>
                            </td>
                            <td>
                                <div className="form-group">
                                    <DatePicker
                                        selected={searchDate}
                                        onChange={(date) => setSearchDate(date) || setStartTime(date)}
                                        className="form-control input-height"
                                        timeIntervals={15}
                                        dateFormat="MMMM d, yyyy"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Start Time of Search*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-group">
                                    <DatePicker
                                        selected={startTime}
                                        onChange={(date) => setStartTime(date) || setEndTime(date)}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="Time"
                                        timeFormat="HH:mm"
                                        dateFormat="h:mm aa"
                                        className="form-control input-height"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>End Time of Search*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-group">
                                    <DatePicker
                                        selected={endTime}
                                        onChange={(date) => setEndTime(date)}
                                        showTimeSelect
                                        showTimeSelectOnly
                                        timeIntervals={15}
                                        timeCaption="Time"
                                        dateFormat="h:mm aa"
                                        className="form-control input-height"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Patient Consent*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        className="form-control input-height"
                                        id="consent-id"
                                        ref={patientConsentRef}
                                        required
                                        aria-describedby="consent-id"
                                        placeholder="enter patient consent"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Patient Present*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        className="form-control input-height"
                                        id="present-search-id"
                                        ref={patientPresentRef}
                                        required
                                        aria-describedby="present-search-id"
                                        placeholder="enter patient presence"
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Justification For Search *</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-group">
                                    <textarea
                                        name="mental-assessment-id"
                                        id="mental-assessment-id"
                                        ref={reasonRef}
                                        className="form-control form-control-textarea"
                                        required
                                        rows="6"
                                        placeholder="enter justification for search"
                                    ></textarea>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Search Members</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Search Member*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-group">
                                    <Select
                                        options={options}
                                        multi={true}
                                        valueField="id"
                                        labelField="display"
                                        onChange={(values) => setMembers(values)}
                                        searchable={true}
                                        color="#0066f5 "
                                        searchBy="display"
                                        addPlaceholder="+ Select Search Members"
                                        clearable={true}
                                        separator={true}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Damage Report</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Prior to Search*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-group">
                                    <input type="text" className="form-control input-height" id="ps-id" ref={priorToSearchRef} required aria-describedby="ps-id" placeholder="enter prior to search" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Post Search*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-group">
                                    <input
                                        type="text"
                                        className="form-control input-height"
                                        id="after-search-id"
                                        ref={postToSearchRef}
                                        required
                                        aria-describedby="after-search-id"
                                        placeholder="enter post search"
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Comments and Observations</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td>
                                <div className="form-group">
                                    <textarea
                                        name="comment-assessment-id"
                                        id="comment-assessment-id"
                                        ref={commentRef}
                                        className="form-control form-control-textarea"
                                        required
                                        rows="6"
                                        placeholder="enter comment"
                                    ></textarea>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="form-group text-center mt-5">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-primary">
                    Submit Search Result <i className="material-icons">keyboard_arrow_down</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle">
                    Cancel <i className="material-icons text-danger">close</i>
                </button>
            </div>
        </form>
    );
};
export default NewRoomSearch;
